import clsx from "clsx";
import { twMerge } from "tailwind-merge";
import { IOption } from "../../types/customizer";
import If from "../If";

import './index.scss';

interface ISwatchOption extends IOption {
  hasSwatch: boolean;
  displayShowMoreOption: boolean;
  fieldType: string;
  onChange: (updated: any) => void;
  selectedOption: IOption;
  isChanging: string;
}

const SwatchOption = ({ type, name, swatch_url, selected, sku, additionalClassName, hasSwatch, displayShowMoreOption, fieldType, onChange, 
  selectedOption, isChanging }: ISwatchOption) => {
  

  const handleClick = () => {
    if(!selected) {
      onChange({ [fieldType]: sku });
    } else {
      if(selectedOption.has_inside_reversed_option) {
          if(selectedOption.is_reverse_selected) {
              onChange({[fieldType]: sku})
          } else {
              onChange({[fieldType]: sku + 'REV'})
          }
      }
  }
  }

  if(hasSwatch) {    
    return (
      <div className={clsx({ "sm:w-28 xs:w-22.5 text-center sm:mr-5 my-2 relative": true })}>
        <div className="xs:px-1.5 sm:px-2">
          <div className={clsx("inline-block relative", {"border border-dashed border-brand-color rounded-full": selected && !isChanging, "selected-border": isChanging.includes(sku)  })} 
            onClick={handleClick}>
            <div className='xs:w-16 xs:h-16 sm:w-22.5 sm:h-22.5 rounded-full cursor-pointer bg-no-repeat bg-center bg-contain m-1'
              style={{ backgroundImage: `url(${process.env.REACT_APP_ASSET_URL}${swatch_url})` }}/>
          </div>
          <div className="secondary-font-family text-sm text-secondary-color mt-1 pl-1 xs:break-all sm:break-normal">{name}</div>
        </div>
      </div>)
  } else {
    return (
      <div className={clsx({ "p-1.5 sm:p-2 cursor-pointer relative": true, "selected-border-square ": isChanging === sku })}>
        <If condition={name || sku}>
          <div className={twMerge(clsx({
            "p-1.5  sm:p-2 border border-solid border-secondary-border-color rounded text-center min-w-18 secondary-font-family text-sm text-secondary-color": true,
            "border-dashed border-brand-color": selected && !isChanging 
          }), `${additionalClassName}`)} onClick={handleClick}>
            {sku === 'CUSTOM' ? sku : name}
          </div>
        </If>
      </div>
    )
  }
}

export default SwatchOption;